import Config from '../config/Config'
import { createApiClient } from './api.utils'

const apiClient = createApiClient(Config.BASE_URL)

export default apiClient
